"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.preview.title': 'Dettagli Azienda',
    'company.preview.failedToLoad': 'Errore nel caricamento delle informazioni aziendali',
    'company.preview.noCompany': 'Nessuna informazione aziendale disponibile',
    'company.preview.section.basic_info': 'Informazioni di Base',
    'company.preview.section.status': 'Stato',
    'company.preview.section.location': 'Posizione',
    'company.preview.section.additional': 'Informazioni Aggiuntive',
};
